interface RoomDetailsCardProps {
  maxPlayers: number;
  gameSpeed: string;
  callerMode: string;
  prizePreset: string;
}

export function RoomDetailsCard({
  maxPlayers,
  gameSpeed,
  callerMode,
  prizePreset,
}: RoomDetailsCardProps) {
  const prizes = [
    'Early Five',
    'Top Line',
    'Middle Line',
    'Bottom Line',
    'Four Corners',
    'Full House',
  ];

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left">
      <div className="space-y-4">
        <h3 className="font-display text-base font-black tracking-wider text-amber-300 uppercase">
          Room Settings
        </h3>

        {/* Room configuration read-only stats */}
        <div className="grid grid-cols-2 gap-3 pb-3 border-b border-white/5">
          <div className="glass-light p-2.5 rounded-xl border border-white/5 text-center">
            <span className="block text-[9px] uppercase tracking-wider text-surface-400 font-bold">
              Max Players
            </span>
            <span className="text-sm font-black font-mono text-white">{maxPlayers}</span>
          </div>

          <div className="glass-light p-2.5 rounded-xl border border-white/5 text-center">
            <span className="block text-[9px] uppercase tracking-wider text-surface-400 font-bold">
              Game Speed
            </span>
            <span className="text-sm font-black uppercase text-white tracking-wide">
              {gameSpeed}
            </span>
          </div>

          <div className="glass-light p-2.5 rounded-xl border border-white/5 text-center">
            <span className="block text-[9px] uppercase tracking-wider text-surface-400 font-bold">
              Caller Mode
            </span>
            <span className="text-sm font-black uppercase text-white tracking-wide">
              {callerMode === 'auto' ? 'Auto' : 'Manual'}
            </span>
          </div>

          <div className="glass-light p-2.5 rounded-xl border border-white/5 text-center">
            <span className="block text-[9px] uppercase tracking-wider text-surface-400 font-bold">
              Prize Preset
            </span>
            <span className="text-sm font-black uppercase text-white tracking-wide">
              {prizePreset}
            </span>
          </div>
        </div>

        {/* Active prizes checkbox list */}
        <div className="space-y-2">
          <h4 className="text-[10px] font-bold uppercase tracking-wider text-surface-400">
            Active Prizes
          </h4>
          <div className="grid grid-cols-2 gap-2">
            {prizes.map((prize) => (
              <div
                key={prize}
                className="flex items-center space-x-2 px-2.5 py-1.5 rounded-lg bg-emerald-500/5 border border-emerald-500/10 text-[10px] font-bold text-emerald-400 uppercase tracking-wide"
              >
                <span>✓</span>
                <span>{prize}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
